import { Redirect, useLocalSearchParams } from 'expo-router';
import { useEffect } from 'react';

import { ANALYTICS_EVENTS } from '@/constants/analytics';
import { EXPERIMENTS } from '@/constants/experiments';
import { FEATURE_FLAGS } from '@/constants/featureFlags';
import {
  AVENTRIA_LANDING_PAGE_FLAG_VALUES,
  AVENTRIA_PEER_SUPPORT_UTM_SOURCE,
  AVENTRIA_SUBSPECIALIST_CONSULT_UTM_SOURCE,
} from '@/constants/redirects';
import { ROUTES } from '@/constants/routes';
import { useFeatureFlagValue } from '@/hooks/useFeatureFlag';
import { segmentClient } from '@/util/analytics';

type UrlParams = {
  flag?: string;
  utm_source?: string;
};

export default function RedirectRoute() {
  const { flag, utm_source } = useLocalSearchParams<UrlParams>();

  const aventriaLandingPageFlagValue = useFeatureFlagValue(FEATURE_FLAGS.AVENTRIA_LANDING_PAGE);

  const params = utm_source ? { utm_source } : undefined;

  useEffect(() => {
    if (flag === FEATURE_FLAGS.AVENTRIA_LANDING_PAGE) {
      segmentClient.track(ANALYTICS_EVENTS.EXPERIMENT_VIEWED, {
        experiment: EXPERIMENTS.AVENTRIA_LANDING_PAGE,
        variant: aventriaLandingPageFlagValue as string,
      });
    }
  }, [flag, aventriaLandingPageFlagValue]);

  if (
    utm_source === AVENTRIA_PEER_SUPPORT_UTM_SOURCE ||
    utm_source === AVENTRIA_SUBSPECIALIST_CONSULT_UTM_SOURCE
  ) {
    return <Redirect href={{ pathname: ROUTES.NEW_QUESTION, params }} />;
  }

  if (flag === FEATURE_FLAGS.AVENTRIA_LANDING_PAGE) {
    if (aventriaLandingPageFlagValue === AVENTRIA_LANDING_PAGE_FLAG_VALUES.INQUIRY) {
      return <Redirect href={{ pathname: ROUTES.INQUIRY, params }} />;
    }

    return <Redirect href={{ pathname: ROUTES.DIRECTORY, params }} />;
  }

  // Default redirect when no matching flag
  return <Redirect href={{ pathname: ROUTES.DIRECTORY, params }} />;
}
